// Lib
import { SIZE_50 } from '@/lib/gridElements/size';
import { LINKEDIN } from '@/lib/socialProfile';
import { classicFormat } from '@/hooks/format/useFormatNumber';

// Components
import { HalfBarLineChart } from '@/components/composite/Charts/HalfBarLineChart';

export const gainedLostFollowersConfig = {
    title: 'chart.linkedin.gained_lost_followers',
    id: 'gained_lost_followers_history',
    margin: {
        left: -25,
        right: -25,
        bottom: 25,
        top: 10
    },
    name: {
        date: 'date',
        gained: 'chart.linkedin.gained_lost_followers_gained',
        lost: 'chart.linkedin.gained_lost_followers_lost',
        total: 'chart.linkedin.gained_lost_followers_total',
        posts: 'chart.linkedin.gained_lost_followers_posts'
    },
    tooltip: 'chart.linkedin.tooltip_gained_lost_followers',
    social: LINKEDIN,
    valueFormat: classicFormat,
    orientation: 'horizontal',
    labelLeftAxis: 'followers',
    labelRightAxis: 'chart.post_engagements.posts',
    color: {
        gained: 'green',
        lost: 'gray',
        posts: 'blue'
    },
    legendTypes: {
        gained: 'square',
        lost: 'square',
        posts: 'line'
    },
    size: SIZE_50,
    type: 'chart',
    element: HalfBarLineChart
};
